var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryAdvance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#EFA00B",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2577_15573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0417 26.4184L29.2784 27.7109L28.5909 28.9026L25.6667 27.2159V23.8334H27.0417V26.4184ZM33 26.5834C33 30.1309 30.1309 33.0001 26.5834 33.0001C23.0359 33.0001 20.1667 30.1309 20.1667 26.5834C20.1667 26.2717 20.1942 25.9692 20.24 25.6667H12.8334V14.6667H29.3334V20.7901C31.4967 21.8259 33 24.0259 33 26.5834ZM20.79 23.8334C20.955 23.5034 21.1292 23.1917 21.34 22.8892C21.2575 22.9167 21.175 22.9167 21.0834 22.9167C19.5617 22.9167 18.3334 21.6884 18.3334 20.1667C18.3334 18.6451 19.5617 17.4167 21.0834 17.4167C22.605 17.4167 23.8334 18.6451 23.8334 20.1667C23.8334 20.3959 23.7967 20.6251 23.7417 20.8359C24.6034 20.4142 25.5659 20.1667 26.5834 20.1667C26.895 20.1667 27.1975 20.1942 27.5 20.2401V18.3334C27.0138 18.3334 26.5475 18.1403 26.2037 17.7964C25.8599 17.4526 25.6667 16.9863 25.6667 16.5001H16.5C16.5 17.5176 15.6842 18.3334 14.6667 18.3334V22.0001C15.1529 22.0001 15.6193 22.1932 15.9631 22.5371C16.3069 22.8809 16.5 23.3472 16.5 23.8334H20.79ZM31.1667 26.5834C31.1667 24.0534 29.1134 22.0001 26.5834 22.0001C24.0534 22.0001 22 24.0534 22 26.5834C22 29.1134 24.0534 31.1667 26.5834 31.1667C29.1134 31.1667 31.1667 29.1134 31.1667 26.5834Z",
    fill: "#EFA00B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2577_15573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryAdvance);
export default __webpack_public_path__ + "static/media/salary-advance.8f78dc194e4d608ab264debb2857aadd.svg";
export { ForwardRef as ReactComponent };